var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIgbo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#C0583B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99754 9.24691H8.11554V15.7539H8.99754V9.24691ZM13.305 9.96691C14.169 9.96691 14.889 10.3809 15.132 11.2089H16.068C15.852 9.95791 14.745 9.13891 13.323 9.13891C11.406 9.13891 10.128 10.5429 10.128 12.5229C10.128 14.5299 11.397 15.8619 13.242 15.8619C14.196 15.8619 14.988 15.4479 15.339 14.8809L15.402 15.7629H16.14V12.1719H13.134V12.9549H15.312V13.1439C15.312 14.4579 14.421 15.0249 13.314 15.0249C11.973 15.0249 11.055 14.1159 11.055 12.5409C11.055 11.0019 11.901 9.96691 13.305 9.96691Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgbo);
export default __webpack_public_path__ + "static/media/igbo.2e16c8bcaffa1f0d437fbb6cfce249c0.svg";
export { ForwardRef as ReactComponent };